import { render, staticRenderFns } from "./App.vue?vue&type=template&id=71ddd0a8&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=71ddd0a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ddd0a8",
  null
  
)

export default component.exports